import { defineMessages } from 'react-intl'

const translations = defineMessages({
  nextDescaling: {
    defaultMessage: 'Next cleaning',
    id: 'msp.account.machine_display_stats.next_descaling'
  },
  nextDescalingAfterCups: {
    defaultMessage: 'After {cups} cups',
    id: 'msp.account.machine_display_stats.next_descaling_cups'
  },
  waterConsumption: {
    defaultMessage: 'Water Consumption',
    id: 'msp.account.machine_display_stats.water_consumption'
  },
  waterConsumptionVolume: {
    defaultMessage: '{volume}',
    id: 'msp.account.machine_display_stats.water_consumption_volume'
  },
  brewedCups: {
    defaultMessage: 'Brewed cups',
    id: 'msp.account.machine_display_stats.brewed_cups'
  },
  brewedCupsNo: {
    defaultMessage: '{cups} Cups',
    id: 'msp.account.machine_display_stats.brewed_cups_no'
  },
  noStats: {
    defaultMessage:
      'No data available. Track your consumption and connect the machine to the app.',
    id: 'msp.account.machine_display_stats.no_stats'
  }
})

export default translations
